import { openBlock as t, createElementBlock as a, createElementVNode as e } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, o = /* @__PURE__ */ e("g", { "clip-path": "url(#a)" }, [
  /* @__PURE__ */ e("path", {
    "fill-rule": "evenodd",
    d: "M2.13.863a.7.7 0 0 1 .7-.7h8.975a.7.7 0 0 1 .382.114l1.97 1.282a.7.7 0 0 1 0 1.174l-1.97 1.282a.7.7 0 0 1-.382.113H9.931v1.343h3.014a.7.7 0 0 1 .7.7v2.565a.7.7 0 0 1-.7.7H9.931v6.094a.7.7 0 0 1-.7.7H6.666a.7.7 0 0 1-.7-.7V9.436H3.97a.7.7 0 0 1-.382-.114L1.618 8.04a.7.7 0 0 1 0-1.173l1.97-1.283a.7.7 0 0 1 .381-.113h1.997V4.128H2.83a.7.7 0 0 1-.7-.7V.863Zm5.236 4.608h1.165V4.128H7.366v1.343Zm0 3.965v5.394h1.165V9.436H7.366ZM3.53 1.563v1.165h8.068l.895-.582-.895-.583H3.53Zm-.246 5.89.894-.582h8.068v1.165H4.177l-.894-.583Z",
    "clip-rule": "evenodd"
  })
], -1), h = /* @__PURE__ */ e("defs", null, [
  /* @__PURE__ */ e("clipPath", { id: "a" }, [
    /* @__PURE__ */ e("path", { d: "M0 0h16v16H0z" })
  ])
], -1), n = [
  o,
  h
];
function c(d, s) {
  return t(), a("svg", l, [...n]);
}
const i = { render: c };
export {
  i as default,
  c as render
};
